import axios from "axios";
import React from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { classNames } from "../helpers";
import { useLocalStorage } from "../hooks";
import { useToast } from "../provider/ToastProvider";
import { loadingState, setActionLoading } from "../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../utils/confighelpers";
import { TwButton } from "./tailwind";
import { useTranslation } from "react-i18next";

export default function OtpModal({
  open,
  handleClose,
  title,
  subTitle,
  values,
  categories,
  reqToken,
  locationChanged,
  updateLocationConfig,
  setLoading,
  onSubmit,
}) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const [userToken] = useLocalStorage("userToken");
  const [otp, setOtp] = React.useState("");
  const [error, setError] = React.useState("");

  const handleChange = (otp) => setOtp(otp);

  const handleSubmit = async () => {
    setError(false);
    if (otp === "") {
      setError(true);
      return false
    }

    dispatch(setActionLoading(true));
    const otpBody = {
      code: otp,
      token: reqToken,
    };
    const otpConfig = {
      method: "put",
      url: `${getUrlForUsers()}verifyPrimaryFieldsOtpAndUpdate`,
      headers: {
        "x-access-token": userToken,
      },
      data: otpBody,
    };
    const otpRequest = await axios(otpConfig);
    dispatch(setActionLoading(false));
    if (otpRequest.data.statusCode !== 200) {
      setError(true);
      addErrorToast(otpRequest.data?.message);
      return;
    } else {
      // addToast("Processing new school data...");
      handleClose();
      onSubmit();
      return false;
    }
  };
  return (<Dialog open={open}
    onClose={(event, reason) => {
      if (reason && reason === "backdropClick") {
        return;
      }
      handleClose();
    }}
    className="relative z-50">
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
    />

    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <DialogPanel
          transition
          className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
        >
          <div>

            <div className="mt-3 text-center sm:mt-5 flex flex-col gap-4">
              <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                {title}
              </DialogTitle>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  {t("forgotPassword.verifyForgotSubTitle1")}<span className="text-gray-900">{subTitle}</span>
                </p>
              </div>
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={4}
                containerStyle={`flex gap-3 justify-center [my-3 md:my-4]`}
                inputStyle={classNames(`!size-12 text-sm/6 text-gray-900 placeholder:text-gray-400 sm:text-base disabled:bg-gray-200 rounded-xl bg-input-bz outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2`,
                  error ? "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
                    : "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
                )}
                renderInput={(props) => <input {...props} />}
                hasErrored={error}
                shouldAutoFocus
                inputType="number"
              />
            </div>
          </div>
          <div className="mt-5 sm:mt-6 flex gap-3 justify-center items-center">
            <TwButton
              variant={"secondary-outline"}
              className="w-full justify-center px-3 py-2 sm:w-auto sm:min-w-28"
              disabled={(loadingReduxState.actionLoading)}
              onClick={() => {
                handleClose();
              }}
            >
              {t("inputFieldsTitle.cancel")}
            </TwButton>
            <TwButton
              variant={"secondary"}
              className="w-full justify-center sm:w-auto sm:min-w-28"
              disabled={(loadingReduxState.actionLoading)}
              actionLoading={(loadingReduxState.actionLoading)}
              onClick={handleSubmit}
            >
              {t("inputFieldsTitle.continue")}
            </TwButton>
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>)
}
